import { render, staticRenderFns } from "./DriverImage.vue?vue&type=template&id=31d674d2&"
import script from "./DriverImage.vue?vue&type=script&lang=js&"
export * from "./DriverImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports